import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { scenarioFourAPI } from 'api/scenarioFourAPI';
import produce from 'immer';

export const fetchScenarioFourStats = createAsyncThunk(
    'scenarioFour/fetchScenarioFourStats',
    async (params) => await scenarioFourAPI.fetchStats(params)
);

export const fetchScenarioFourOutliers = createAsyncThunk(
    'scenarioFour/fetchScenarioFourOutliers',
    async (params) => await scenarioFourAPI.fetchOutliers(params)
);

const initialState = {
    stats: null,
    outlierData: null,
    outliersIsFetched: false,
    selectedOutlier: null,
    selectedRM: null
};

const scenarioFourSlice = createSlice({
    name: 'scenarioFour',
    initialState,
    reducers: {
        setSelectedOutlier: (state, { payload }) =>
            produce(state, (draft) => {
                draft.selectedOutlier = payload;
            }),
        setSelectedRM: (state, { payload }) =>
            produce(state, (draft) => {
                draft.selectedRM = payload;
            }),
        resetAll: () => initialState
    },
    extraReducers: (builder) => {
        builder.addCase(
            fetchScenarioFourStats.fulfilled,
            (state, { payload }) =>
                produce(state, (draft) => {
                    const { statsReporting } = payload;
                    draft.stats = statsReporting;
                })
        );
        builder.addCase(
            fetchScenarioFourOutliers.fulfilled,
            (state, { payload }) =>
                produce(state, (draft) => {
                    const { outlierData } = { ...payload };
                    draft.outlierData = outlierData;
                    draft.outliersIsFetched = true;
                })
        );
    }
});

const { actions, reducer: scenarioFourReducer } = scenarioFourSlice;
export const { setSelectedOutlier, setSelectedRM, resetAll } = actions;
export default scenarioFourReducer;
